/**
 * Product Carousel Service - Get all required data
 *
 * @memberof CouponCarousel
 */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BehaviorSubject, of, Subject } from "rxjs";

// Data Model

import { CouponCarouselModel } from "../models/data.model";
import { CommonService } from "./common.service";
import { J4uV1Service } from "./j4u-v1.service";
import { AemService } from "./aem.service";

@Injectable({
  providedIn: "root",
})
export class LoyaltyCarouselService {
  public AB = window["AB"];
  public coupons = [];
  public offersData = new BehaviorSubject<any>({});
  public offersDataSource = this.offersData.asObservable();
  public slickChanges = new Subject();
  public slickChanges$ = this.slickChanges.asObservable();

  constructor(
    private _http: HttpClient,
    private _commonService: CommonService,
    private _aemService: AemService,
    private _j4uV1Service: J4uV1Service
  ) {}

  public getData(couponsCarousel: CouponCarouselModel): Observable<any> {
    let arrCoupon: any[];
    switch (couponsCarousel.carouselFilter) {
      case "aisle":
        if(this._aemService.getDisableEcomGalleryApi()){
          return this._commonService.loadRemoteCouponsV2(couponsCarousel.includePageName)
        }
        break;
      case "qualifyingoffers":
        return this._j4uV1Service.getData();
      case "j4uGallery":
        couponsCarousel.carouselOfferLimit = couponsCarousel.carouselOfferLimit
          ? Number(couponsCarousel.carouselOfferLimit)
          : 12;
        if (couponsCarousel.offerCarouselApiBased) {
          return this._j4uV1Service.getApiData(
            couponsCarousel.carouselOfferLimit
          );
        } else {
          return this._j4uV1Service.getData(couponsCarousel.carouselOfferLimit);
        }
      case 'p13n':
        return this._j4uV1Service.getP13nData(couponsCarousel.carouselOfferLimit, couponsCarousel.modelConfigurationId);
    }
    return of(arrCoupon);
  }

  public getQualifyingOffers(data, offerId): CouponCarouselModel[] {
    const arrCoupons = [];
    let offerCategory = data.find(function (value) {
      const offerid = value.offerId == null ? value.couponID : value.offerId;
      return offerid === offerId;
    });
    if (offerCategory !== undefined) {
      offerCategory = offerCategory.category;

      for (const index in data) {
        const objOffer = data[index];
        if (
          objOffer.category === offerCategory &&
          (objOffer.offerId === null ? objOffer.couponID : objOffer.offerId) !==
            offerId
        ) {
          if (objOffer.purchaseInd === "B") {
            arrCoupons.unshift(objOffer);
          } else {
            arrCoupons.push(objOffer);
          }
        }
      }
    }
    return arrCoupons.splice(0, 12);
  }

  public setAriaLabelForCouponCarousel(elemRef, carouselTitle) {
    const Carousel_next_button = elemRef.querySelector(".slick-next");
    const Carousel_prev_button = elemRef.querySelector(".slick-prev");
    const next_aria_label = "Next " + carouselTitle;
    const prev_aria_label = "Previous " + carouselTitle;
    if (Carousel_next_button != null) {
      Carousel_next_button.setAttribute("aria-label", next_aria_label);
      Carousel_prev_button.setAttribute("aria-label", prev_aria_label);
    }
  }

  public setOffersData(data) {
    this.offersData.next(data);
  }
}
